import React from "react";
import Modal from "../../component/Inc/Modal";
function PopPRBooklet(props) {
  const { open, close } = props;
  return (
    <Modal open={open} close={close} type="pop_pr_booklet" popSize="s">
      <h2 className="pop_tit">홍보책자 발송 신청</h2>
      <div className="content_container scroll">
        <div className="com_info">
          <p className="name">홍길동103</p>
          <p className="date dot">2025, 05, 20 11 : 30</p>
        </div>
        <div className="check">
          <input
            type="radio"
            name="rdo"
            id="rdo_01"
            className="com_chk circle"
          />
          <label htmlFor="rdo_01">비회원 학생</label>
          <input
            type="radio"
            name="rdo"
            id="rdo_02"
            className="com_chk circle"
          />
          <label htmlFor="rdo_02">학생</label>
          <input
            type="radio"
            name="rdo"
            id="rdo_03"
            className="com_chk circle"
          />
          <label htmlFor="rdo_03">직접입력</label>
        </div>
        <table className="com_board_list type_row">
          <colgroup>
            <col width="140px" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>받는 사람 이름</th>
              <td>
                <section className="com_board_search">
                  <article className="search">
                    <input
                      type="search"
                      placeholder="수신자 검색"
                      className="input xs"
                    />
                    <button className="com_btn gray ws xs icon_search"></button>
                  </article>
                </section>
              </td>
            </tr>
            <tr>
              <th>받는 사람 전화번호</th>
              <td>
                <input
                  type="text"
                  className="input wl"
                  placeholder="010-2020-2222"
                />
              </td>
            </tr>
            <tr>
              <th rowSpan={2}>시범강의 장소</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input wl" placeholder="주소" />
                  <button className="com_btn gray xs">우편번호</button>
                </div>
              </td>
            </tr>
            <tr>
              <td className="border_left">
                <input type="text" className="input wl" placeholder="주소" />
              </td>
            </tr>
          </tbody>
        </table>
        <textarea className="textarea" placeholder="내용 입력"></textarea>

        <div className="pop_board_tit">보낼 홍보 책자 선택</div>

        <table className="com_board_list type_row">
          <colgroup>
            <col width="140px" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>홍보책자 연도 선택</th>
              <td>
                <div className="com_input_wrap">
                  <select className="select">
                    <option value="2023">2023</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th>홍보책자 선택</th>
              <td>
                <div className="com_input_wrap">
                  <select className="select">
                    <option value="홍보책자 선택">홍보책자 선택</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th>권 수 입력</th>
              <td>
                <div className="com_input_wrap">
                  <select className="select">
                    <option value="10권">10권</option>
                  </select>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <p className="com_red_txt">* 재고 부족으로 신청할 수 없습니다.</p>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopPRBooklet;
